import React from 'react';
import { BACK_BTN_LABEL, FormBuilder, SUBMIT_BTN_LABEL } from 'commons-ui';
import { FORM_FIELD_CONFIG, FORM_LAYOUT_CONFIG } from '../../formConfig';
import useCreate from './useCreate';

const CreateFeatureSegment: React.FC<{}> = () => {
	const { data, showLoader, handleFormSubmit, handleFormCancel, setShowLoader } = useCreate();
	return (
		<FormBuilder
			data={data}
			mode='create'
			showLoader={showLoader}
			handleFormSubmit={handleFormSubmit}
			handleFormCancel={handleFormCancel}
			setShowLoader={setShowLoader}
			fieldConfig={FORM_FIELD_CONFIG}
			layoutConfig={FORM_LAYOUT_CONFIG}
			buttonLabels={{ discardLabel: BACK_BTN_LABEL, submitLabel: SUBMIT_BTN_LABEL }}
		/>
	);
};

export default CreateFeatureSegment;
